angular.module('picmonicng').component('ltiDashboardComponent', {
  templateUrl: '/templates/app/pages/lti-dashboard/lti-dashboard.html',
  bindings: {},
  controller: [
    'UserService',
    'User',
    function (UserService, User) {
      var ctrl = this;
      ctrl.UserService = UserService;
      ctrl.deliveries = [];
      ctrl.page = 0;
      ctrl.offset = 0;
      ctrl.total = null;

      ctrl.addDeliveries = function (deliveries, prepend) {
        angular.forEach(deliveries, function (delivery) {
          if (delivery.format === 'json' && delivery.request_body) {
            try {
              delivery.request_body = JSON.stringify(JSON.parse(delivery.request_body), null, 2);
            } catch (error) {
              console.error(error);
            }
          }
        });

        ctrl.deliveries = prepend ? [].concat(deliveries).concat(ctrl.deliveries) : ctrl.deliveries.concat(deliveries);
      };

      ctrl.loadMore = function () {
        if (ctrl.loading) {
          return;
        }

        ctrl.loading = true;
        ctrl.page++;
        User.getv3(
          { resource: 'lti-deliveries', page: ctrl.page, offset: ctrl.offset },
          function (data) {
            ctrl.addDeliveries(data.results);
            ctrl.total = data.total;
            ctrl.loading = false;
          },
          function () {
            ctrl.loading = false;
          }
        );
      };

      ctrl.loadMore();

      ctrl.redeliver = function (delivery) {
        if (ctrl.delivering || delivery.delivering) {
          return;
        }

        ctrl.delivering = delivery.delivering = true;

        User.savev3(
          { resource: 'lti-deliveries', resource_id: delivery.lti_delivery_id },
          function (data) {
            ctrl.addDeliveries(data, true);
            ctrl.total++;
            ctrl.offset++;
            ctrl.delivering = delivery.delivering = false;
          },
          function () {
            ctrl.delivering = delivery.delivering = false;
          }
        );
      };
    },
  ],
});
